const baseURL = process.env.REACT_APP_API_BASE_URL
  ? `${process.env.REACT_APP_API_BASE_URL}/api`
  : "https://api.requerix.online/api";


function errorMessageFrom(payload, fallback) {
  if (!payload) return fallback;

  let obj = payload;

  if (typeof obj === "string") {
    try {
      obj = JSON.parse(obj);
    } catch {
      return obj;
    }
  }

  if (obj.errorMessage) return obj.errorMessage;

  if (obj.error) {
    return errorMessageFrom(obj.error, fallback);
  }
  return fallback;
}

async function parseResponse(resp, defaultMsg) {
  if (resp.ok) return resp.json();

  let payload;
  try {
    payload = await resp.json();
  } catch {
    throw new Error(defaultMsg);
  }

  const message = errorMessageFrom(payload, defaultMsg);
  throw new Error(message);
}

export async function getPresignedUrl(fileName) {
  const resp = await fetch(
    `${baseURL}/url-prefirmada?fileName=${encodeURIComponent(fileName)}`
  );
  return parseResponse(resp, "Error al obtener URL prefirmada");
}

export async function uploadToS3(presignedPost, file) {
  const formData = new FormData();
  Object.entries(presignedPost.fields).forEach(([k, v]) =>
    formData.append(k, v)
  );
  formData.append("file", file);

  const resp = await fetch(presignedPost.url, { method: "POST", body: formData });
  if (!resp.ok) throw new Error("Error al subir archivo a S3");
}

export async function analyzePDF(userId, s3Key) {
  const resp = await fetch(`${baseURL}/analizarPDF`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ userId, s3Key })
  });
  return parseResponse(resp, "Error al analizar PDF");
}
